module.exports = __webpack_public_path__ + "img/ime_plus_white.0a678ec3.svg";